import { gsap } from 'gsap/all';
import Logger from './logger';
import * as THREE from 'three';
import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js';
import { EXRLoader } from 'three/examples/jsm/loaders/EXRLoader.js';
import { degToRad } from 'three/src/math/MathUtils.js';

class MixtapeCurrent extends HTMLElement {
  #NAME ='MixtapeCurrent';
  #bitmapLoader;
  scene;
  renderer;
  camera;
  cassette;
  width;

  constructor() {
    super();
    Logger.info(`${this.#NAME} > constructor`);
    //
    this.scene = new THREE.Scene();
    this.scene.background = null;
    this.camera = new THREE.PerspectiveCamera( 75, this.clientWidth / this.clientHeight, 0.1, 1000 );
    this.camera.position.z = 13;
    this.camera.position.y = 6;
    //
    this.renderer = new THREE.WebGLRenderer({ alpha: true, antialias: true, preserveDrawingBuffer: true });
    this.renderer.setPixelRatio( window.devicePixelRatio );
    this.renderer.setSize( this.clientWidth, this.clientHeight );
    this.renderer.toneMappingExposure = 2;
    this.appendChild( this.renderer.domElement );
    //
    const light = new THREE.AmbientLight( 0xFFFFFF, 1.5 ); // soft white light
    this.scene.add( light );
    //
    /* const dirLight = new THREE.DirectionalLight( 0xFFFFFF, 0.8 );
    dirLight.position.set(0, 0, 30);
    this.scene.add( dirLight ); */
    //
    const dirLight2 = new THREE.DirectionalLight( 0xFFFFFF, 2);
    dirLight2.position.set(30, -4, -5);
    this.scene.add( dirLight2 );
    //
    const dirLight3 = new THREE.DirectionalLight( 0xFFFFFF, 1.3 );
    dirLight3.position.set(-20, 20, -20);
    this.scene.add( dirLight3 );
    //
  }

  connectedCallback() {
    Logger.info(`${this.#NAME} > connectedCallback`);
    const pmremGenerator = new THREE.PMREMGenerator( this.renderer );
		pmremGenerator.compileEquirectangularShader();
    //
    /* THREE.DefaultLoadingManager.onLoad = ( ) => {
      console.log('onload')
      pmremGenerator.dispose();
    }; */
    //
    new EXRLoader().load( '/wp-content/themes/wonderpress/static/dist/images/cassette_in_case.exr', ( texture ) => {
      texture.mapping = THREE.EquirectangularReflectionMapping;
      this.exrTarget = pmremGenerator.fromEquirectangular( texture );
      pmremGenerator.dispose();
      //
      const loader = new GLTFLoader();
      loader.load( 
        '/wp-content/themes/wonderpress/static/dist/images/cassette_in_case_2.gltf', 
        (e) => this.#onLoadGLTF(e), 
        null, 
        (e) => this.#onLoadGTLFError(e)
      );
    } );
  }

  #onLoadGLTF( gltf ) {
    Logger.info(`${this.#NAME} > onLoadGTLF`);
    console.log(gltf);
    this.cassette = gltf.scene;
    this.cassette.rotation.set(0,0, degToRad(26) );
    this.cassette.traverse(child => {
      if (child.material?.name === 'Glass') {
        child.material.roughness = 0;
        /* child.material.metalness = 1; */
        child.material.envMap = this.exrTarget.texture;
        console.log(child.material);
      }
    });
    this.scene.add( this.cassette );

    this.renderer.setAnimationLoop( () => this.#render() );
    gsap.to(this.cassette.rotation, {
      y: degToRad(360),
      duration: 10,
      repeat: -1,
      ease: 'linear'
    });
    
    this.dispatchEvent(new Event('mixtape:current:ready', { bubbles: true }));
  }

  #onLoadGTLFError(error) {
    Logger.info(`${this.#NAME} > #onLoadGTLFError > ${error}`);
  }

  #render() {
    this.renderer.render( this.scene, this.camera );
  }

  setCard(cardUrl, stickerUrl) {
    Logger.info(`${this.#NAME} > setCard > ${cardUrl}, ${stickerUrl}`);
    //
    if (!this.#bitmapLoader) this.#bitmapLoader = new THREE.ImageBitmapLoader();
    //
    this.cassette.traverse(child => {
      /* console.log(child.material); */
      if (cardUrl && child.material && child.material.name === 'Case_paper') {
        this.#bitmapLoader.load(
          cardUrl, 
          (imageBitmap) => {
            const texture = new THREE.CanvasTexture( imageBitmap );
            texture.flipY = false;
            texture.colorSpace = 'srgb';
            texture.wrapS = 1000;
            texture.wrapT = 1000;
            //
            const origMaterial = child.material.clone();
            origMaterial.map = texture;
            child.material = origMaterial;
            /* this.#render(); */
          },
          undefined,
          (err) => {
            console.log(err);
          }
        );
      } else if (stickerUrl && child.material && child.material.name === 'Black_plasatic_cassette_sticker') {
        this.#bitmapLoader.load(
          stickerUrl, 
          (imageBitmap) => {
            const texture = new THREE.CanvasTexture( imageBitmap );
            texture.flipY = false;
            texture.colorSpace = 'srgb';
            texture.wrapS = 1000;
            texture.wrapT = 1000;
            //
            const origMaterial = child.material.clone();
            origMaterial.map = texture;
            child.material = origMaterial;
            /* this.#render(); */
          },
          undefined,
          (err) => {
            console.log(err);
          }
        );
      }
    });
  }

  onResize() {
    Logger.info(`${this.#NAME} > onResize`);
    if (this.camera /* && this.width != this.clientWidth */) {
      this.camera.aspect = this.clientWidth / this.clientHeight;
      this.camera.fov = window.innerWidth < 720 ? 67 : 75;
      this.camera.updateProjectionMatrix();
      this.renderer.setSize( this.clientWidth, this.clientHeight );
      /* this.#render(); */
      this.width = this.clientWidth;
    }
  }

}

customElements.define('mixtape-current', MixtapeCurrent);